import React from 'react';
import { useNavigate } from 'react-router-dom';
import s from './404.module.css'; // Create this file in the same folder

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className={s.container}>
      <div className={s.content}>
        <div className={s.errorCode}>
          <span>4</span>
          <div className={s.circle}>
            <div className={s.eye}></div>
          </div>
          <span>4</span>
        </div>
        
        <h1 className={s.title}>Lost in Space?</h1>
        <p className={s.message}>
          The page you are looking for doesn't exist or has been moved to another galaxy.
        </p>

        <div className={s.actions}>
          <button onClick={() => navigate(-1)} className={s.btnSecondary}>
            Go Back
          </button>
          <button onClick={() => navigate('/')} className={s.btnPrimary}>
            Return Home
          </button>
        </div>
      </div>
      
      {/* Decorative background elements */}
      <div className={s.starOne}></div>
      <div className={s.starTwo}></div>
    </div>
  );
}